fieldsToDirty_1